import React from 'react';
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';
  
const PageNotFound = () => {
    return (
          <div>
          <Bar/>
          <section id="PageNotFound" className="PageNotFound">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Page Not Found 404</h2>
            <h4>
            Ea vitae aspernatur deserunt voluptatem impedit deserunt magnam
            occaecati dssumenda quas ut ad dolores adipisci aliquam
          </h4>
            </div>
            </div>
            </section>
          <Footer/>
          </div>
    );
  };
  
  export default PageNotFound;